import { Card, CardHeader, CardPreview, Field, Input, Textarea, Title1, Title2, Title3, Toolbar, ToolbarDivider, ToolbarToggleButton } from "@fluentui/react-components";
import { TextBold24Regular, TextItalic24Regular, TextUnderline24Regular } from "@fluentui/react-icons";
import { Tendering } from "../../../models/tendering";
import { ChangeEvent, Dispatch, FC, SetStateAction } from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface TenderingInfoProps {
  tenderingDocument: Tendering;
  updateTenderingData: Dispatch<SetStateAction<Tendering>>;
}

const TenderingInformation: FC<TenderingInfoProps> = ({
  tenderingDocument,
  updateTenderingData,
}) => {
  
  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    data: { value: string }
  ) => {
    const name = event.target.name;
    const value = data.value;

    const properties = name.split('.');
    
    if(properties.length == 1){
      updateTenderingData((prev) => ({
        ...prev,
        [name]: value
      }));
    }
    else{
      updateTenderingData((prev) => ({
        ...prev,
        [properties[0]]: {
          ...(prev[properties[0] as keyof Tendering] as object),
          [properties[1]]: value
        }
      }));
    }
  };


  return(
    <Card className="flex-1 w-2xl">
      <CardPreview>
        <Title3>Information</Title3>
      </CardPreview>
      <div className="overflow-y-auto p-2">
        <Field
          label="Namn på ramavtal:"
          required
        >
        <Input 
          name="tenderingName" 
          value={tenderingDocument.tenderingName} 
          onChange={handleChange}
        />
        </Field>
        <Field
          label="Term för sök:"
          required
        >
        <Input
          name="properties.tenderingSearchNameText" 
          value={tenderingDocument.properties.tenderingSearchNameText} 
          onChange={handleChange}
        />
        </Field>
        <Field
          label="Beskrivning av avtal"
          validationState="success"
          className="mb-10"
          required
        >
          <ReactQuill
            theme="snow"
            className="rounded-quill-editor"
            value={tenderingDocument.properties.tenderingDescription || ''}
            onChange={(value) => {
              updateTenderingData((prev) => ({
                ...prev,
                properties: {
                  ...prev.properties,
                  tenderingDescription: value
                }
              }));
            }}
          />
        </Field>
        <Field
          label="Infomationstext för process:"
          validationState="success"
          className="mb-10"
          required
        >
          <ReactQuill 
            theme="snow"
            className="rounded-quill-editor"
            value={`${tenderingDocument.properties.tenderingProcessText}`} 
            onChange={(value) => {
              updateTenderingData((prev) => ({
                ...prev,
                properties: {
                  ...prev.properties,
                  tenderingProcessText: value
                }
              }));
            }}
          />
        </Field>
        <Field
          label="Term för förfrågan:"
          required
        >
        <Input
          name="properties.tenderingPlacementText"
          value={tenderingDocument.properties.tenderingPlacementText} 
          onChange={handleChange} 
        />
        </Field>
        <Field
          label="Registrering utanför avtal - Varningstext:"
          validationState="success"
          className="mb-10"
          required
        >
          <ReactQuill
            theme="snow"
            className="rounded-quill-editor"
            value={`${tenderingDocument.properties.placementOutsideTenderingWarning ? tenderingDocument.properties.placementOutsideTenderingWarning : ''}`} 
            onChange={(value) => {
              updateTenderingData((prev) => ({
                ...prev,
                properties: {
                  ...prev.properties,
                  placementOutsideTenderingWarning: value
                }
              }));
            }}
          />
        </Field>
        <Field
          label="Registrering utanför avtal - POST-länk:"
          required
        >
        <Input
          name="properties.powerAutomateUrl" 
          value={tenderingDocument.properties.powerAutomateUrl} 
          onChange={handleChange}
        />
        </Field>
      </div>
    </Card>
  )
}

export default TenderingInformation;